import Vue from "vue";
import VueRouter from "vue-router";
import SignIn from "../user/pages/UserSignIn.vue";
import InvoiceDownload from "../accounts/pages/InvoiceDownload.vue";
import AccountDeletion from "../accounts/pages/AccountDeletion.vue";
import { lockedFeatureOf, hasPlanBackend } from "../utils/entitlements";
import { isOnboardingBlocked, isAllowedDuringOnboarding, ONBOARDING_ROUTE } from "../utils/onboarding-gate";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "SignIn",
    component: SignIn,
    meta: { display: false, redirectAuthUser: true },
  },
  {
    path: "/dashboardold",
    name: "DashboardOld",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../user/pages/Dashboard.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../user/pages/DashboardNew.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/invoice-download/:id",
    name: "InvoiceDownload",
    component: InvoiceDownload,
    meta: { display: false },
  },
  {
    path: "/delete",
    name: "AccountDeletion",
    component: AccountDeletion,
    meta: { display: false },
  },
  {
    // Public (no login): each tenant's own privacy policy, on the tenant's own domain
    path: "/privacy-policy",
    name: "PrivacyPolicyPublic",
    component: () => import("../accounts/pages/PrivacyPolicy.vue"),
    meta: { display: false },
  },
  {
    path: "/menuitems",
    name: "MenuItems",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/MenuItems.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/meal-details",
    name: "MealDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/MealDetails.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/inactive-customers",
    name: "InActiveCustomers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/InActiveCustomers.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/menucategory",
    name: "MenuCategory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/MenuCategory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/category-types",
    name: "CategoryTypes",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/MenuCategoryTypes.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/plans",
    name: "Packages",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/Packages.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/managers",
    name: "ManagersMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../managers/pages/ManagersMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/notifications",
    name: "NotificationMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../notifications/pages/NotificationMain.vue"),
    meta: { requiresAuth: true, feature: "push_notifications" },
  },
  {
    path: "/CustomerDietitianAppt",
    name: "CustomerDietitianAppointment",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/components/dietitian/CustomerDietitianAppointment.vue"),
    meta: { requiresAuth: true, feature: "dietitian_clinic" },
  },

  // {
  //   path: '/settings',
  //   name: 'SettingsMain',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../settings/pages/SettingsMain.vue'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/faq",
    name: "Faq",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../faq/pages/FaqMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/contact-method",
    name: "ContactMethod",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../contact-method/pages/ContactMethod.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/api-user",
    name: "APIUsers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../api-user/pages/APIUsers.vue"),
    meta: { requiresAuth: true, feature: "public_api" },
  },
  {
    path: "/customertags",
    name: "CustomerTag",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomerTag.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customers",
    name: "CustomerMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomerMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/customer_details",
    name: "CustomerDetails",
    component: () => import("../customer/pages/CustomerDetails.vue"),
    props: true,
    meta: { requiresAuth: true },
  },
  {
    path: "/customers-with-no-meals",
    name: "CustomersWithNoMeals",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomersWithNoMeals.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dietician_details",
    name: "DietitianDetails",
    component: () => import("../dietitian/pages/DietitianDetails.vue"),
    props: true,
    meta: { requiresAuth: true, feature: "dietitian_clinic" },
  },
  {
    path: "/stock",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../stock/pages/StockMain.vue"),
    children: [
      {
        path: "stock_details",
        name: "StockDetails",
        component: () => import("../stock/pages/StockDetails.vue"),
        props: true,
        meta: { requiresAuth: true, feature: "inventory" },
      },
      {
        path: "purchase",
        name: "StockPurchase",
        component: () => import("../stock/pages/StockPurchase.vue"),
        meta: { requiresAuth: true, feature: "inventory" },
      },
      {
        path: "adjust_stock",
        name: "StockAdjust",
        component: () => import("../stock/pages/StockAdjust.vue"),
        meta: { requiresAuth: true, feature: "inventory" },
      },
      {
        path: "master_data",
        name: "StockMaster",
        component: () => import("../stock/pages/StockMaster.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "units",
        name: "Units",
        component: () => import("../stock/pages/Units.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "brand",
        name: "Brand",
        component: () => import("../stock/brand/pages/Brand.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "vendor",
        name: "Vendor",
        component: () => import("../stock/pages/Vendor.vue"),
        meta: { requiresAuth: true },
      },
      {
        path: "monthlyUsage",
        name: "MonthlyUsage",
        component: () => import("../stock/pages/MonthlyUsage.vue"),
        meta: { requiresAuth: true, feature: "inventory" },
      },
      {
        path: "monthlyPurchase",
        name: "MonthlyPurchase",
        component: () => import("../stock/pages/MonthlyPurchase.vue"),
        meta: { requiresAuth: true, feature: "inventory" },
      },
    ],
    meta: { requiresAuth: true },
  },
  // {
  //   path: '/stock/master_data',
  //   name: 'StockMaster',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../stock/pages/StockMaster.vue'),
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/orders",
    name: "OrdersMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/OrdersMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/rating",
    name: "Ratings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/MealRatings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/delivery",
    name: "DeliveryMain",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../delivery/pages/DeliveryMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/areas",
    name: "CustomerArea",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomerArea.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/salesorder",
    name: "SalesOrder",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/abandonedcart",
    name: "AbandonedCart",
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inactivesalesorder",
    name: "InactiveSalesOrder",
    // route level code-splittingsrc\orders\components\inactiveSalesOrderTable.vue
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/inactivesalesordercount",
    name: "InactiveSalesOrderCount",
    // route level code-splittingsrc\orders\components\inactiveSalesOrderTable.vue
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/salesorderdaywise",
    name: "SalesOrderDayWise",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/sales-order-discount",
    name: "SalesOrderDiscount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../orders/pages/SalesOrder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/drivers",
    name: "Drivers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/drivers.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/referrals",
    name: "Referrals",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../referral-transactions/pages/ReferralsPage"),
    meta: { requiresAuth: true, feature: "referral_program" },
  },
  {
    path: "/dieticians",
    name: "Dietitians",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../dietitian/pages/dietitianView.vue"),
    meta: { requiresAuth: true, feature: "dietitian_clinic" },
  },
  {
    path: "/admins",
    name: "Admins",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../admins/pages/AdminsMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/celebrity",
    name: "Celebrity",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../celebrity/pages/CelebrityView.vue"),
    meta: { requiresAuth: true, feature: "celebrity" },
  },
  {
    path: "/celebrity_info",
    name: "CelebrityInfo",
    component: () => import("../celebrity/pages/CelebrityInfo.vue"),
    props: true,
    meta: { requiresAuth: true, feature: "celebrity" },
  },
  {
    path: "/appointments",
    name: "Appointments",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../appointments/pages/AppointmentsView.vue"),
    meta: { requiresAuth: true, windDown: "dietitian_clinic" },
  },
  {
    path: "/sales",
    name: "Sales",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../sales/pages/SalesMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/detailed-sales",
    name: "DetailedSales",
    component: () => import("../sales/pages/DetailedSalesMain.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports",
    name: "ReportsHome",
    component: () => import("../reports/pages/ReportsHome.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/delivery-intelligence",
    name: "DeliveryIntelligence",
    component: () => import("../reports/pages/DeliveryIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/order-production",
    name: "OrderProduction",
    component: () => import("../reports/pages/OrderProduction.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/ingredient-requirement",
    name: "IngredientRequirement",
    component: () => import("../reports/pages/IngredientRequirement.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/promo-code-performance",
    name: "PromoPerformance",
    component: () => import("../reports/pages/PromoPerformance.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/executive-business-overview",
    name: "ExecutiveOverview",
    component: () => import("../reports/pages/ExecutiveOverview.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/sales-intelligence",
    name: "SalesIntelligence",
    component: () => import("../reports/pages/SalesIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/subscription-intelligence",
    name: "SubscriptionIntelligence",
    component: () => import("../reports/pages/SubscriptionIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/customer-intelligence",
    name: "CustomerIntelligence",
    component: () => import("../reports/pages/CustomerIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/meal-menu-intelligence",
    name: "MealMenuIntelligence",
    component: () => import("../reports/pages/MealMenuIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/production-intelligence",
    name: "ProductionIntelligence",
    component: () => import("../reports/pages/ProductionIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/ingredient-purchasing-intelligence",
    name: "IngredientPurchasing",
    component: () => import("../reports/pages/IngredientPurchasing.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/food-cost-intelligence",
    name: "FoodCostProfitability",
    component: () => import("../reports/pages/FoodCostProfitability.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/inventory-intelligence",
    name: "InventoryIntelligence",
    component: () => import("../reports/pages/InventoryIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/marketing-promotion-intelligence",
    name: "MarketingPromotion",
    component: () => import("../reports/pages/MarketingPromotion.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/dietitian-operations-intelligence",
    name: "DietitianOperations",
    component: () => import("../reports/pages/DietitianOperations.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/sales-ledger",
    name: "SalesLedger",
    component: () => import("../reports/pages/SalesLedger.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/package-detail",
    name: "PackageDetail",
    component: () => import("../reports/pages/PackageDetail.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/package-performance",
    name: "PackagePerformance",
    component: () => import("../reports/pages/PackagePerformance.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/customers-without-meal",
    name: "CustomersWithoutMeal",
    component: () => import("../reports/pages/CustomersWithoutMeal.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/paused-meals",
    name: "PausedMeals",
    component: () => import("../reports/pages/PausedMeals.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/driver-intelligence",
    name: "DriverIntelligence",
    component: () => import("../reports/pages/DriverIntelligence.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/reports/:slug",
    name: "ReportPlaceholder",
    component: () => import("../reports/pages/ReportPlaceholder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promocode-report",
    name: "PromoCodeReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/PromoCodeReport.vue"),
    meta: { requiresAuth: true, feature: "promo_codes" },
  },
  {
    path: "/shop-discount",
    name: "ShopDiscount",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../discount/pages/Discount.vue"),
    meta: { requiresAuth: true, feature: "shop" },
  },
  {
    path: "/mealtags",
    name: "MealsTag",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/pages/MealsTag.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/report-status",
    name: "ReportStatus",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/ReportStatus.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/pausedmeals-report",
    name: "PausedMealsReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/PausedMealsReport.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/meal-order-count-report",
    name: "MealOrderCountReport",
    component: () => import("../reports/pages/MealOrderCountReport.vue"),
    meta: { requiresAuth: true },
  },

  {
    path: "/referral-report",
    name: "ReferralReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/ReferralReport.vue"),
    meta: { requiresAuth: true, feature: "referral_program" },
  },
  {
    path: "/otp-details",
    name: "UserOTPDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/UserOTPDetails.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/promocodes",
    name: "PromoCode",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../promotion/pages/PromoCode.vue"),
    meta: { requiresAuth: true, feature: "promo_codes" },
  },
  {
    path: "/driver-report",
    name: "DriverReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/DriverReport.vue"),
  },
  {
    name: "PromoCodeDetails",
    path: "/promocode_details",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../promotion/pages/PromoCodeDetails.vue"),
    meta: { requiresAuth: true, feature: "promo_codes" },
  },
  {
    path: "/delivery-locations",
    name: "DeliveryLocations",
    component: () => import(/* webpackChunkName: "about" */ "../location/pages/DeliveryLocations.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/shifts",
    name: "CustomerShift",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomerShift.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/zones",
    name: "CustomerZone",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/pages/CustomerZone.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/offers",
    name: "Offers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../offer/pages/OfferView.vue"),
    meta: { requiresAuth: true, feature: "offers" },
  },
  {
    path: "/permission",
    name: "Permission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../permission/pages/Permission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/add-permission",
    name: "AddPermission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../permission/pages/AddPermission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/update-permission",
    name: "UpdatePermission",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../permission/pages/AddPermission.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/staff-info",
    name: "StaffInfo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../managers/pages/ManagerInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/dietplan",
    name: "DietPlan",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../menu-packages/diet-plan/pages/DietPlan.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/error-404",
    name: "Error404",
    component: () => import("../core/pages/Error404.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/end-date-reminder",
    name: "EndDateReminder",
    component: () => import("../orders/pages/EndDateReminder.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts",
    name: "AccountTransactions",
    component: () => import("../accounts/pages/AccountTransactions.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/universal-pause",
    name: "UniversalPause",
    component: () => import("../universal-pause/pages/UniversalPause.vue"),
    meta: { requiresAuth: true, windDown: "universal_pause" },
  },
  {
    path: "/plan-switch",
    name: "PlanSwitch",
    component: () => import("../plan-switch/pages/PlanSwitch.vue"),
    meta: { requiresAuth: true, feature: "plan_switch" },
  },
  {
    path: "/profile-settings",
    name: "ProfileSettings",
    component: () => import("../settings/pages/PreferencesForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/configurations-settings",
    name: "ConfigurationsSettings",
    component: () => import("../settings/pages/Configurations.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/portion-settings",
    name: "PortionSettings",
    component: () => import("../settings/pages/PortionSettings.vue"),
    meta: { requiresAuth: true, feature: "portioning" },
  },
  {
    path: "/pdf-templates",
    name: "PdfTemplates",
    component: () => import("../pdf-templates/pages/PdfTemplates.vue"),
    meta: { requiresAuth: true, feature: "pdf_templates" },
  },
  {
    path: "/terms-and-conditions-settings",
    name: "TermsAndConditionsSettings",
    component: () => import("../settings/pages/TermsForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/privacy-policy-settings",
    name: "PrivacyPolicySettings",
    component: () => import("../settings/pages/PrivacyPolicySettings.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/tutorials-settings",
    name: "TutorialsSettings",
    component: () => import("../settings/pages/TutorialForm.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/branch-list",
    name: "BranchList",
    component: () => import("../branch/pages/BranchList.vue"),
    meta: { requiresAuth: false },
  },
  {
  path: "/system-appearance",
  name: "SystemAppearance",
  component: () =>
    import(
      
      "../settings/pages/SystemAppearance.vue"
    ),
  meta: { requiresAuth: true },
},
  {
    path: "/configure-mobile-app",
    name: "ConfigureMobileApp",
    component: () =>
      import(
        
        "../settings/pages/MobileAppConfiguration.vue"
      ),
    meta: { requiresAuth: true, feature: "mobile_app" },
  },
  {
    path: "/whatsapp-settings",
    name: "WhatsAppSettings",
    component: () => import("../whatsapp-settings/pages/WhatsAppSettings.vue"),
    meta: { requiresAuth: true, feature: "whatsapp" },
  },
  {
    path: "/dietitian-appointment-list",
    name: "DietitianAppointmentList",
    component: () => import("../dietitianSlotBooking/pages/DietitanAppointmentList.vue"),
    meta: { requiresAuth: true, windDown: "dietitian_clinic" },
  },
  {
    path: "/monthly-customer-sales",
    name: "MonthlyCustomerSalesReport",
    component: () => import("../reports/pages/MonthlyCustomerSalesReport.vue"),
    meta: { feature: "advanced_reports" },
  },
  {
    path: "/dietician_slot_appointment",
    name: "DietitianSlotAppointment",
    component: () => import("../dietitian/dietitian_settings/pages/DietitianSlotAppointments.vue"),
    props: true,
    meta: { requiresAuth: true, feature: "dietitian_clinic" },
  },
  {
    path: "/dietician_plan_suggestion",
    name: "PlanSuggestions",
    component: () => import("../dietitian/dietitian_settings/pages/PlanSuggestions.vue"),
    props: true,
    meta: { requiresAuth: true, feature: "dietitian_clinic" },
  },
  {
    path: "/dietician-appointment-report",
    name: "DietitianAppointmentReport",
    component: () => import("../dietitian/dietitian_settings/pages/DietitianAppointmentReport.vue"),
    props: true,
    meta: { requiresAuth: true, windDown: "dietitian_clinic" },
  },
  {
    path: "/schedule-notification",
    name: "ScheduleNotification",
    component: () => import("../schedule-notification/pages/ScheduleNotificationMain.vue"),
    meta: { requiresAuth: true, feature: "push_notifications" },
  },
  {
    path: "/online-refund",
    name: "Refund",
    component: () => import("../accounts/pages/Refund.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/add-package",
    name: "AddPackage",
    component: () => import("../menu-packages/pages/AddPackage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/update-package",
    name: "UpdatePackage",
    component: () => import("../menu-packages/pages/UpdatePackage.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/gateway-charges",
    name: "GatewayCharge",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../gateway-charges/pages/GatewayCharges.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/bills-and-payments",
    name: "BillsAndPayments",
    component: () => import("../bills-and-payments/pages/BillsAndPayments.vue"),
    meta: { requiresAuth: true },
  },
  {
    // SaaS plan, usage and plan comparison; a locked route lands here with ?locked=<feature>.
    // Only once the SaaS backend serves plans (the status response carries `entitlements`).
    path: "/my-plan",
    name: "MyPlan",
    component: () => import("../bills-and-payments/pages/MyPlan.vue"),
    meta: { requiresAuth: true, requiresPlanBackend: true },
  },

  {
    path: "/freeze-list",
    name: "FreezeList",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../customer/components/freeze/FreezeList.vue"),
    meta: { requiresAuth: true, windDown: "freeze" },
  },
  {
    path: "/plan-transfer-report",
    name: "PlanTransferReport",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/PlanTransferList.vue"),
    meta: { requiresAuth: true, feature: "plan_transfer" },
  },
  {
    path: "/plan-switch-report",
    name: "PlanSwtichHistoryFullDetails",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/CustomerPlanSwitchHistory.vue"),
    meta: { requiresAuth: true, windDown: "plan_switch" },
  },
  {
    path: "/plan-payment-report",
    name: "PlanPaymentHistory",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/PlanPaymentHistory.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/products",
    name: "ProductsListing",
    component: () => import("../ecommerse/page/Products.vue"),
    meta: { requiresAuth: true, feature: "shop" },
  },
  {
    path: "/product-category",
    name: "ProductCategory",
    component: () => import("../ecommerse/page/ProductCategory.vue"),
    meta: { requiresAuth: true, feature: "shop" },
  },
  {
    path: "/shopping-order",
    name: "ShoppingOrder",
    component: () => import("../ecommerse/page/Order.vue"),
    meta: { requiresAuth: true, windDown: "shop" },
  },
  {
    path: "/customer-shopping",
    name: "CustomerShopping",
    component: () => import("../ecommerse/page/Shopping.vue"),
    meta: { requiresAuth: true, feature: "shop" },
  },
  {
    path: "/shopping",
    name: "ShoppingOrder",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../ecommerse/page/ShoppingOrder.vue"),
    meta: { requiresAuth: false, windDown: "shop" },
  },
  {
    path: "/customer-gender-report",
    name: "CustomerGenderWiseReport",
    component: () => import("../customer/pages/CustomerGenderWiseReport.vue"),
    meta: { requiresAuth: true, feature: "advanced_reports" },
  },
  {
    path: "/customer-age-report",
    name: "CustomerAgeWiseReport",
    component: () => import("../customer/pages/CustomerAgeWiseReport.vue"),
    meta: { requiresAuth: true, feature: "advanced_reports" },
  },
  {
    path: '/package-report',
    name: 'PackageReport',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../reports/pages/PackageReport.vue'),
    meta: { feature: "advanced_reports" },

  },
  {
    path: '/package-review',
    name: 'PackageReview',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../menu-packages/pages/PackageReview.vue'),
    meta: { requiresAuth: true }
  },
  {

    path: "/homepage-settings",
    name: "HomePageSettings",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../homepage-settings/pages/HomePagePackageSettings.vue"),
    meta: { requiresAuth: true, feature: "web_storefront" },
  },
  {
    path: "/article",
    name: "Article",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../article/pages/Article.vue"),
    meta: { requiresAuth: true, feature: "web_storefront" },
  },
  {
    path: "/contactUs",
    name: "contactUs",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../reports/pages/ContactUsList.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/set-menu-assign",
    name: "AssignToDriver",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import("../set-menu/pages/AssignToDriver.vue"),
    meta: { requiresAuth: true, windDown: "set_menu" },
  },
  {
    path: "/set-menu-report-master",
    name: "SetMenuReportMaster",
    component: () => import("../set-menu/pages/SetMenuReportMasterDetails.vue"),
    props: false,
    meta: { requiresAuth: true, windDown: "set_menu" },
  },
  {
    path: "/set-menu-order-delivery",
    name: "SetMenuOrderDelivery",
    component: () => import("../set-menu/pages/SetMenuOrderDelivery.vue"),
    props: false,
    meta: { requiresAuth: true, windDown: "set_menu" },
  },

  {
    path: "/set-menu-customer-list",
    name: "SetMenuCustomerList",
    component: () => import("../set-menu/pages/SetMenuCustomerList.vue"),
    props: false,
    meta: { requiresAuth: true, windDown: "set_menu" },
  },
  {
    path: "/set-menu-meals-list",
    name: "SetMenuMeals",
    component: () => import("../set-menu/pages/SetMenuMeals.vue"),
    props: false,
    meta: { requiresAuth: true, windDown: "set_menu" },
  },
  {
    path: "/integration",
    redirect: "/integration-payment",
  },
  {
    path: "/integration-payment",
    name: "IntegrationPayment",
    component: () => import("../integrations/pages/IntegrationPayment.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/integration-messaging",
    name: "IntegrationMessaging",
    component: () => import("../integrations/pages/IntegrationMessaging.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/integration-push-notifications",
    name: "IntegrationPushNotifications",
    component: () => import("../integrations/pages/IntegrationPushNotifications.vue"),
    meta: { requiresAuth: true, feature: "push_notifications" },
  },
  {
    path: "/integration-gallabox-whatsapp",
    name: "IntegrationGallabox",
    component: () => import("../integrations/pages/IntegrationGallabox.vue"),
    meta: { requiresAuth: true, feature: "whatsapp" },
  },
];

// path: '/settings',
// name: 'SettingsMain',
// // route level code-splitting
// // this generates a separate chunk (about.[hash].js) for this route
// // which is lazy-loaded when the route is visited.
// component: () => import('../settings/pages/SettingsMain.vue'),
// meta: { requiresAuth: true }
// },
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  const auth = localStorage.getItem("apollo-done-token");

  // NB: this guard used to do `i18n.locale = to.params.lang || "en"`. No route
  // declares a :lang segment, so the fallback always won and every navigation
  // reset the locale to English — including the first route resolved after
  // boot, which undid the user's saved preference while leaving the document
  // still in RTL. Locale is owned by src/i18n.js (boot) and
  // utils/language-service.js (changes); the router must not touch it.

  // redirect unauth users to Signin  page
  if (to.meta.requiresAuth && !auth) {
    next({ name: "SignIn" });
  } else if (to.meta.redirectAuthUser && auth) {
    // redirect Dashboard page for autheticated users
    next({ name: "Dashboard" });
  } else if (to.meta.requiresPlanBackend && !hasPlanBackend()) {
    // My plan before the SaaS backend serves plans: nothing to show yet
    next({ name: "Dashboard" });
  } else if (auth && to.meta.requiresAuth && !isAllowedDuringOnboarding(to.path) && (await isOnboardingBlocked())) {
    // Mandatory onboarding step (privacy policy) still open: finish it first. The backend
    // rejects admin changes until then; this just avoids sending the admin into dead ends.
    next({ path: ONBOARDING_ROUTE, query: { onboarding: "1" } });
  } else {
    // SaaS plan gate: a route whose meta.feature is not in the tenant's plan opens My plan
    // instead (never without an entitlements snapshot — utils/entitlements.js fails open)
    const lockedFeature = lockedFeatureOf(to);
    if (lockedFeature) {
      next({ name: "MyPlan", query: { locked: lockedFeature } });
    } else {
      next();
    }
  }
});

// Lets the report stylesheets (reports/styles/reportMenus.css) restyle dropdown menus on report pages only.
router.afterEach(to => {
  document.body.classList.toggle("in-reports", to.path.indexOf("/reports") === 0);
});

export default router;